'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
function isBlank(text) {
  if (text == null) {
    return true
  }
  var trimmedText = String(text).trim()
  return trimmedText == ''
}
exports.default = isBlank
//# sourceMappingURL=isBlank.js.map
